module.exports = __webpack_public_path__ + "static/media/hero.51476b2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hall-farm-holiday-lets/hero.jpg
// module id = 57
// module chunks = 0